import { render, staticRenderFns } from "./BaseFormGroupArray.vue?vue&type=template&id=ab6bc58c&"
import script from "./BaseFormGroupArray.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroupArray.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormGroupArray.vue?vue&type=style&index=0&id=ab6bc58c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports